import { Injectable } from '@angular/core';
import { Tramite } from '../interfaces/tramite';
import { App } from '../interfaces/app';

@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  tramites: Tramite[];
  apps: App[];

  constructor() {}

  getTramites() {
    this.tramites = [
      {
        name: 'GLOBAL.CONSULTAR.INFORMACION.GENERAL',
        url: '/',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.PREGUNTAS.FRECUENTES',
        url: '/preguntas-frecuentes',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.POLITICA.PRIVACIDAD',
        url: '',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.ACCESO.INFORMACION.AYUNTAMIENTO',
        url: '',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.VISUALIZAR.MAPA',
        url: '',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.VISUALIZACION.NOTICIAS',
        url: 'objetivo',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.INFORMACION.USUARIO',
        url: '',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.APP.DISPONIBLES',
        url: '',
        type: 0,
      },
      {
        name: 'GLOBAL.CONSULTAR.FORMULARIO.CONTACTO',
        url: '',
        type: 0,
      },

      {
        name: 'GLOBAL.CONSULTAR.CONDICIONES.DE.USO',
        url: '',
        type: 1,
      },
      {
        name: 'GLOBAL.CONSULTAR.GESTION.SESION.ESTACIONAMIENTO',
        url: '',
        type: 1,
      },
      {
        name: 'GLOBAL.CONSULTAR.REGISTRO.PLATAFORMA',
        url: '',
        type: 1,
      },
      {
        name: 'GLOBAL.CONSULTAR.GESTION.VEHICULOS',
        url: '',
        type: 1,
      },
      {
        name: 'GLOBAL.CONSULTAR.VISUALIZACION.HISTORIAL.APARCAMIENTOS',
        url: '',
        type: 1,
      },
      {
        name: 'GLOBAL.CONSULTAR.GESTION.FAVORITOS.PARADAS.RUTAS',
        url: '',
        type: 1,
      },
      {
        name: 'GLOBAL.CONSULTAR.ACCESO.PRIVADO.ADMNISTRACION.CONSULTA.INFORMACION',
        url: '',
        type: 2,
      },
      {
        name: 'GLOBAL.CONSULTAR.REGISTRO.PLATAFORMA',
        url: '',
        type: 2,
      },
      {
        name: 'GLOBAL.CONSULTAR.GESTION.VEHICULOS',
        url: '',
        type: 2,
      },
      {
        name: 'GLOBAL.CONSULTAR.GESTION.INFORMACION.USUARIO',
        url: '',
        type: 2,
      },
      {
        name: 'GLOBAL.CONSULTAR.GESTION.CAMBIO.CONTRASEÑA',
        url: '',
        type: 2,
      },
      {
        name: 'GLOBAL.CONSULTAR.CONTACTO.SOPORTE.TECNICO',
        url: '',
        type: 1,
      },
    ];
    return this.tramites;
  }
  getAvailableApps() {
    this.apps = [
      {
        name: 'DuminVal Android',
        storeUrl: 'https://play.google.com/store',
        imgUrl: 'logo_duminval.png',
        description: '',
      },
      {
        name: 'DuminVal iOS',
        storeUrl: 'https://www.apple.com/es/ios/app-store/',
        imgUrl: 'logo_duminval.png',
        description: '',
      },
      {
        name: 'Telpark Aparcamiento regulado',
        storeUrl:
          'https://play.google.com/store/apps/details?id=com.delaware.empark',
        imgUrl: 'telpark.png',
        description:
          'Telpark es la aplicación que te permite pagar y gestionar el estacionamiento en zonas reguladas tipo zona azul y zona verde en la vía pública, utilizando tu teléfono móvil smartphone sin necesidad de llevar dinero en efectivo ni buscar un parquímetro.',
      },
      {
        name: 'Auvasa Bus',
        storeUrl: 'https://play.google.com/store/apps/details?id=auvasa.bus',
        imgUrl: 'auvasa.png',
        description:
          'Auvasa BUS es la aplicación oficial para seguir puntualmente toda la información del servicio de transporte urbano en la ciudad de Valladolid. Consulta el tiempo de espera en la parada, accede a las últimas noticias de interés, recorridos y horarios de líneas, medios de pago ... y mucho más.',
      },
      {
        name: 'Vallabici',
        storeUrl:
          'https://play.google.com/store/apps/details?id=com.ingeniasolucionesenmovilidad.vallabici',
        imgUrl: 'vallabici.png',
        description:
          'A través de la aplicación podrá consultar ubicación de las estaciones de alquiler de bicicletas, así como disponibilidad de bicicletas y candados libres en tiempo real.',
      }
    ];

    return this.apps;
  }
}
